import MenuScreen from './MenuScreen';

export default MenuScreen;
